import React from "react";
import Card from "react-bootstrap/Card";
import NavigationBar from "../../Components/NavigationBar";
import { useNavigate } from "react-router-dom";
import {
  FileText,
  ClipboardList,
  Send,
  Lock,
  CheckCircle,
  View,
  List,
  NotepadText,
  Info,
  BookCheck,
  CircleUserRound,
} from "lucide-react"; // Import Lucide icons
import "./Dashboard.css";

function Dashboard() {
  const navigate = useNavigate();

  // Retrieve user role from local storage
  const userRole = localStorage.getItem("role");

  // Define card data with icons based on role
  const applicantCards = [
    {
      title: "Download Application Templates",
      link: "/applicationtemplates",
      icon: <FileText size={40} />,
    },
    {
      title: "Apply for Award",
      link: "/applicationform",
      icon: <ClipboardList size={40} />,
    },
    {
      title: "View Submitted Applications",
      link: "/submittedapplications",
      icon: <Send size={40} />,
    },
    { title: "APC Applications",
      link: "/apcapplications", 
      icon: <Info size={40} /> },
    {
      title: "Change Password",
      link: "/changepassword",
      icon: <Lock size={40} />,
    },
  ];

  const directorCards = [
    {
      title: "Upload Application Template",
      link: "/awardapplications",
      icon: <FileText size={40} />,
    },
    {
      title: "View Applications",
      link: "/submittedapplicationsd",
      icon: <View size={40} />,
    },
    {
      title: "Evaluate and Shortlist Applications",
      link: "/shorlistapplications",
      icon: <ClipboardList size={40} />,
    },
     {
      title: "Evaluate and Approve Applications - URC",
      link: "/approveapplicationurc",
      icon: <ClipboardList size={40} />,
    },

    {
      title: "Submit for Review and Aprrove (Dean) ",
      link: "/approveawards",
      icon: <CheckCircle size={40} />,
    },
     {
      title: "Submit for Review and Aprrove (MC Member)",
      link: "/approveawardsmc",
      icon: <CheckCircle size={40} />,
    },
   
    {
      title: "APC (Shortlisted Applications)- Request Payment",
      link: "/apc",
      icon: <NotepadText size={40} />,
    },

    {
      title: "Send Completed APC Applications (Bursar)",
      link: "/sendcompletedapplications",
      icon: <Send size={40} />,

    },
 
    {
      title: "All Shortlisted Application Information",
      link: "/allapplicationDetails",
      icon: <List size={40} />,
    },

    {
      title: "Application Open & Close Dates",
      link: "/applicationdates",
      icon: <List size={40} />,
    },
    // {
    //   title: "Finalized Applications",
    //   link: "/finalapplications",
    //   icon: <BookCheck size={40} />,
    // },

    {
      title: "Change Password",
      link: "/changepassword",
      icon: <Lock size={40} />,
    },
  {
      title: "Create New Account",
      link: "/createaccount",
      icon: <CircleUserRound size={40} />,
    },
  
   
  ];


  const SecretaryCards = [
      {
      title: "Upload Application Template",
      link: "/awardapplications",
      icon: <FileText size={40} />,
    },
    {
      title: "View Applications",
      link: "/submittedapplicationsd",
      icon: <View size={40} />,
    },
    {
      title: "Evaluate and Shortlist Applications",
      link: "/shorlistapplications",
      icon: <ClipboardList size={40} />,
    },
     {
      title: "Evaluate and Approve Applications - URC",
      link: "/approveapplicationurc",
      icon: <ClipboardList size={40} />,
    },

    {
      title: "Submit for Review and Aprrove (Dean) ",
      link: "/approveawards",
      icon: <CheckCircle size={40} />,
    },
     {
      title: "Submit for Review and Aprrove (MC Member)",
      link: "/approveawardsmc",
      icon: <CheckCircle size={40} />,
    },
   
    {
      title: "APC (Shortlisted Applications)- Request Payment",
      link: "/apc",
      icon: <NotepadText size={40} />,
    },

    {
      title: "Send Completed APC Applications (Bursar)",
      link: "/sendcompletedapplications",
      icon: <Send size={40} />,

    },
 
    {
      title: "All Shortlisted Application Information",
      link: "/allapplicationDetails",
      icon: <List size={40} />,
    },

      {
      title: "Application Open & Close Dates",
      link: "/applicationdates",
      icon: <List size={40} />,
    },
    // {
    //   title: "Finalized Applications",
    //   link: "/finalapplications",
    //   icon: <BookCheck size={40} />,
    // },

    {
      title: "Change Password",
      link: "/changepassword",
      icon: <Lock size={40} />,
    },
  {
      title: "Create New Account",
      link: "/createaccount",
      icon: <CircleUserRound size={40} />,
    },
  
  ];

  // Determine which set of cards to display
  const cardsToDisplay =
    userRole === "Applicant"
      ? applicantCards
      : userRole === "Director"
      ? directorCards
      :userRole === "Secretary"
      ? SecretaryCards
      : [];

  // Function to navigate on card click
  const handleCardClick = (link) => {
    navigate(link);
  };

  return (
    <div>
      <NavigationBar />
      <label className="heading">
        {/* {userRole === "Applicant" ? "Apply for New Award Here" : ""} */}
      </label>
      <div className="d-flex flex-wrap">
        {cardsToDisplay.map((card, index) => (
          <Card
            key={index}
            className="card-item"
            onClick={() => handleCardClick(card.link)}
          >
            <Card.Body className="text-center">
              <div className="icon-container">{card.icon}</div>{" "}
              {/* Display Lucide icon */}
              <Card.Title className="cardtitle">{card.title}</Card.Title>
            </Card.Body>
          </Card>
        ))}
      </div>
    </div>
  );
}

export default Dashboard;
